import React from "react";

/**
 * Renders sponsor text at the largest font size that fits the column:
 * no word may overflow maxWidth and the wrapped text may take at most
 * maxLines lines. Sized via canvas measurement of the scoreboard font.
 */
export function FitSponsorText(props: { maxLines?: number, maxWidth?: number, text: string }) {
	const maxWidth = props.maxWidth || 260;
	const maxLines = props.maxLines || 3;
	const canvas = document.createElement("canvas");
	const context = canvas.getContext("2d");

	// Safety margin: canvas metrics can run narrower than the board's real
	// font rendering, and words must never be split mid-word.
	const fitWidth = maxWidth * 0.88;

	const fits = (size: number) => {
		if (!context) return true;
		context.font = `bold ${size}px Rockwell, sans-serif`;
		const words = props.text.split(" ");
		if (words.some((word) => context.measureText(word).width > fitWidth)) return false;
		let lines = 1, line = "";
		for (const word of words) {
			const test = line ? `${line} ${word}` : word;
			if (context.measureText(test).width > fitWidth) { lines++; line = word; }
			else line = test;
		}
		return lines <= maxLines;
	};

	let size = 58;
	while (size > 20 && !fits(size)) size -= 2;

	return <h3 style={{ fontSize: size, lineHeight: 1.1, margin: 0, maxWidth, width: "100%" }}>{props.text}</h3>;
}
